import React, { useEffect, useRef, useState } from 'react';
import { LANGUAGES } from '../i18n/languages';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, setLanguage, t, meta } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  const activeLabel = `${meta.nativeName}${meta.beta ? ' (Beta)' : ''}`;

  return (
    <div className="lang-select" ref={wrapRef}>
      <button
        type="button"
        className={`lang-select-btn${meta.beta ? ' is-beta' : ''}`}
        title={`${t.nav.selectLanguage}: ${activeLabel}`}
        aria-label={`${t.nav.selectLanguage}: ${activeLabel}`}
        aria-expanded={open}
        aria-haspopup="listbox"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="lang-select-flag" aria-hidden="true">{meta.flag}</span>
      </button>

      {open && (
        <div className="lang-select-menu" role="listbox" aria-label={t.nav.selectLanguage}>
          <div className="lang-select-heading">{t.nav.language}</div>
          {LANGUAGES.map((item) => {
            const selected = item.code === language;
            return (
              <button
                key={item.code}
                type="button"
                role="option"
                aria-selected={selected}
                className={`lang-select-option${selected ? ' is-selected' : ''}`}
                onClick={() => {
                  setLanguage(item.code);
                  setOpen(false);
                }}
              >
                <span className="lang-select-option-flag" aria-hidden="true">{item.flag}</span>
                <span className="lang-select-option-name">{item.nativeName}</span>
                {item.beta && <span className="lang-select-beta">Beta</span>}
                {selected && (
                  <svg className="lang-select-check" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
